// import the react components
import React, { useState } from "react";
import NavigationDrawer from "./navigation-drawer";
import { Link } from "react-router-dom";
import { gradient_primary } from "../assets/data/colors";
import { MdLogin } from "react-icons/md";
import { HiMenuAlt3, HiX } from "react-icons/hi";

// the outer header of the website
const OuterHeader = ({ special_buttom = true }) => {
    const [open, set_open] = useState(false);

    // the navigation links
    const nav_links = [
        { to: "developer", title: "developer"},
        { to: "contact", title: "contact" },
    ];
    special_buttom && nav_links.push({
        to: "login",
        title: "login",
        is_button: true,
        icon: <MdLogin size={20} />,
    });

    return (
        <>
            <div className="-m-5 px-6 flex justify-between items-center h-24 relative z-40">
                <Link to="/" onClick={() => set_open(false)}>
                    <h1 className="logo-text text-3xl font-bold tracking-tight text-primary dark:brightness-150">
                        Light<span className="">Dent</span>
                    </h1>
                </Link>

                <nav className="hidden sm:flex gap-x-4 items-center">
                    {nav_links.map(item => (
                        <Link
                            key={item.title}
                            to={`/${item.to}`}
                            className={`capitalize hover:opacity-80 dark:text-gray-200 transition-opacity ${item.is_button ? "transition-opacity duration-100 hover:opacity-90 py-2 px-5 text-gray-100 rounded-full text-lg flex justify-center items-center gap-1" : "text-xl"}`}
                            style={{ background: item.is_button ? gradient_primary : "" }}
                        >
                            {item.title}
                            {item.icon && item.icon}
                        </Link>
                    ))}
                </nav>

                <button
                    className="sm:hidden flex items-center justify-center w-10 h-10 rounded-xl text-gray-700 dark:text-gray-200 hover:bg-gray-100 dark:hover:bg-gray-800 transition-colors"
                    onClick={() => set_open(prev => !prev)}
                    aria-label="Toggle menu"
                >
                    {open ? <HiX size={30} /> : <HiMenuAlt3 size={30} />}
                </button>
            </div>

            {open && <div className="fixed inset-0 bg-black/40 z-40 sm:hidden" onClick={() => set_open(false)} />}
            <NavigationDrawer open={open} set_open={set_open} nav_links={nav_links} special_buttom={special_buttom} />
        </>
    );
};
export default OuterHeader;